import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';

@Component({
  selector: 'app-post-statement-tapal',
  templateUrl: './post-statement-tapal.component.html',
  styleUrls: ['./post-statement-tapal.component.scss'],
})
export class PostStatementTapalComponent implements OnInit {
  poststatementdata;

  weight_of_bundle;
  postal_rates;
  sub_mode;
  dis_mode;
  weight_of_copy;
  number_of_copies_in_bundle;

  dispatchdate: any;
  issuedate: any;
  dis_sub_mode: any;
  today;
  prakashandate;
  vitarandate;
  vajan;
  tapalrate;
  tempdata = [];
  data1 = [];
  total_sub_count = 0;
  Filteredpoststatementdata = [];
  tempdata1 = [];
  FilteredData = [];
  totalgatthe = 0;
  totalank = 0;
  totalvajan = 0;
  totalaakar = 0;
  totaltapalank = 0;
  disRepData = [];
  subDistributionMode: any
  constructor(
    private dialogref: MatDialogRef<PostStatementTapalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }

  ngOnInit(): void {
    // this.service .getDistributionRepresentativeSBhetHastewise() .subscribe((res) => {
    //     this.disRepData = res;
    //   });
    // console.log('This is post tapal', this.data['data']);

    this.sub_mode = this.data['mode'];
    this.dis_mode = this.data['dis_mode'];
    this.weight_of_bundle = this.data['weight_of_bundle'];
    this.prakashandate = this.data['prakashandate'];
    this.dispatchdate = this.data['dispatchdate'];
    this.issuedate = this.data['issuedate'];
    this.vitarandate = this.data['vitarandate'];
    this.subDistributionMode = this.data['dis_sub_mode']
    this.today = formatDate(new Date(), 'dd/MM/yyyy', 'en-IN', 'GMT+0530');
    this.vajan = this.data['vajan'];
    this.tapalrate = this.data['tapalrate'];



    this.getDataAllDistributer();

    // this.poststatementdata = this.data['data'].filter((a) => {
    //   return (
    //     a['delivery_mode'] === 'हस्ते' &&
    //     a['dis_mode'] === this.dis_mode &&
    //     a['dis_sub_mode'] === this.sub_mode
    //   );
    // });
    // this.totaltapalank = this.data['data'].filter((a) => {
    //   return a['delivery_mode'] === 'टपाल';
    // }).length;
    // // console.log(this.poststatementdata, this.totaltapalank);

    // this.tempdata = this.uniqueid(
    //   this.poststatementdata,
    //   (a) => a['distribution_rep']
    // );

    // let arr = [];
    // this.tempdata.map((a) => {
    //   arr.push(a.distribution_rep);
    // });

    // setTimeout(() => {
    //   if (this.dis_mode != '' && this.sub_mode != '') {
    //     this.disRepData = this.disRepData.filter(
    //       (a) =>
    //         !arr.includes(a.dis_rep_name) &&
    //         a['dis_mode'] === this.dis_mode &&
    //         a['dis_sub_mode'] === this.sub_mode
    //     );
    //   } else if (this.dis_mode != '' && this.sub_mode == '') {
    //     this.disRepData = this.disRepData.filter(
    //       (a) =>
    //         !arr.includes(a.dis_rep_name) && a['dis_mode'] === this.dis_mode
    //     );
    //   } else {
    //     this.disRepData = this.disRepData.filter(
    //       (a) => !arr.includes(a.dis_rep_name)
    //     );
    //   }
    //   // console.log(this.disRepData);
    // }, 600);

    // this.sortDataRepresentativewise();
  }

  sortDataRepresentativewise() {
    this.total_sub_count = 0;
    for (let index = 0; index < Object.keys(this.tempdata).length; index++) {
      let data = this.poststatementdata.filter(
        (a) => a['distribution_rep'] == this.tempdata[index]['distribution_rep']
      );

      let val =
        this.tempdata[index]['s_bhet'] === null
          ? 0
          : parseInt(this.tempdata[index]['s_bhet']);

      this.total_sub_count += Object.keys(data).length + val;
      this.data1.push(data);
      this.Filteredpoststatementdata.push({
        Subscription_Type: this.tempdata[index]['Subscription_Type'],
        address: this.tempdata[index]['address'],
        country: this.tempdata[index]['country'],
        delivery_mode: this.tempdata[index]['delivery_mode'],
        district: this.tempdata[index]['district'],
        entry_date: this.tempdata[index]['entry_date'],
        mobileNumber: this.tempdata[index]['mobileNumber'],
        name: this.tempdata[index]['name'],
        office_rep_name: this.tempdata[index]['office_rep_name'],
        pincode: this.tempdata[index]['pincode'],
        rep_mob_no: this.tempdata[index]['rep_mob_no'],
        rep_name: this.tempdata[index]['rep_name'],
        dis_rep_name: this.tempdata[index]['distribution_rep'],
        state: this.tempdata[index]['state'],
        sub_perid_to_date: this.tempdata[index]['sub_perid_to_date'],
        taluka: this.tempdata[index]['taluka'],
        title: this.tempdata[index]['title'],
        postal_rates: this.tempdata[index]['postal_rates'],
        weight_of_bundle: this.tempdata[index][' weight_of_bundle'],


        dis_mode: this.tempdata[index]['dis_mode'],
        dis_sub_mode: this.tempdata[index]['dis_sub_mode'],
        sub: Object.keys(data).length + val,
      });
    }
    // console.log(this.data1);
    // console.log(this.tempdata);
    console.log(this.Filteredpoststatementdata, "dispatch for post");
    setTimeout(() => {
      this.disRepData.map((a) => {
        let val = a['dis_s_bhet'] === null ? 0 : parseInt(a['dis_s_bhet']);
        this.total_sub_count += val;
        this.Filteredpoststatementdata.push({
          Subscription_Type: '',
          address: '',
          country: '',
          delivery_mode: a['delivery_mode'],
          district: '',
          entry_date: '',
          mobileNumber: '',
          name: '',
          office_rep_name: '',
          pincode: '',
          rep_mob_no: '',
          rep_name: '',
          dis_rep_name: a['dis_rep_name'],
          state: '',
          sub_perid_to_date: '',
          taluka: '',
          title: '',
          dis_mode: a['dis_mode'],
          //  weight_of_bundle: a[' vajan'],
          dis_sub_mode: a['dis_sub_mode'],
          dis_add: a['dis_add'],
          dis_country: a['dis_country'],
          dis_dist: a['dis_dist'],
          dis_pin: a['dis_pin'],
          dis_state: a['dis_state'],
          dis_tal: a['dis_tal'],
          dis_s_bhet: a['dis_s_bhet'] === null ? 0 : a['dis_s_bhet'],
          sub: a['dis_s_bhet'] === null ? 0 : parseInt(a['dis_s_bhet']),
        });
      });
      // console.log(this.Filteredpoststatementdata);
    }, 600);

    setTimeout(() => {
      this.tempdata1 = this.uniqueid(
        this.Filteredpoststatementdata,
        (a) => a['sub']
      );
      // console.log(this.tempdata1);

      for (let index = 0; index < Object.keys(this.tempdata1).length; index++) {
        let data = this.Filteredpoststatementdata.filter(
          (a) => a['sub'] == this.tempdata1[index]['sub']
        );

        let ank =
          parseInt(this.tempdata1[index]['sub']) * Object.keys(data).length;
        let aakar = ank * this.tapalrate;
        this.totalaakar += aakar;
        this.totalank += ank;
        this.totalgatthe += Object.keys(data).length;

        this.FilteredData.push({
          prati: this.tempdata1[index]['sub'],
          gatthe: Object.keys(data).length,
          ank: ank,
          vajan: this.vajan,
          gatthchevajan: 0,
          tapalrate: this.tapalrate,
          aakar: aakar,
        });
      }
      // console.log(this.FilteredData);
      for (
        let index = 0;
        index < Object.keys(this.FilteredData).length;
        index++
      ) {
        let temp;
        for (
          let j = index + 1;
          j < Object.keys(this.FilteredData).length;
          j++
        ) {
          if (
            this.FilteredData[index]['prati'] > this.FilteredData[j]['prati']
          ) {
            temp = this.FilteredData[j];
            this.FilteredData[j] = this.FilteredData[index];
            this.FilteredData[index] = temp;
          }
        }
      }
    }, 700);
    // console.log(this.FilteredData);
  }

  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }
  saveSubscriptionBarcodesDataEntry() {
    const filteredData = this.FilteredData.map((item) => ({
      issue_date: this.convertDateFormat1(this.issuedate),
      country: "भारत",
      status: "A",
      distribution_mode: this.dis_mode,
      state: item.state,
      district: item.dis_dist,
      place: item.dis_dist,
      total: this.total_sub_count,
      added_by: 1,
      prati: item.prati,
      dispatch_date: this.convertDateFormat(this.dispatchdate),
      delivery_mode: item.delivery_mode,
      publish_date: this.convertDateFormat(this.dispatchdate),
      sub_distribution_mode: this.subDistributionMode,
      distribution_representative: item.issueSellerName,
      weight_of_copy: item.vajan,
      postal_rates: item.tapalrate,
      number_of_copies_in_bundle: this.totalank,
      weight_of_bundle: this.vajan,
      total_bundle: this.totalgatthe,
      total_books: (Number(this.totaltapalank) + Number(this.totalank)),
      total_shape_amt: (Number(this.totalaakar) + Number(this.totaltapalank) * Number(this.tapalrate)),
      shape: item.aakar,
      allDistributerId:item.id,

    }));


    console.log(filteredData);
    this.service.saveDispatchStatementDataEntry(filteredData).subscribe((data) => {
      alert('Dispatch Statement Save Successfully!');
    });
  }
  convertDateFormat(dateStr: string): string {
    const [day, month, year] = dateStr.split('/');
    return `${year}/${month}/${day}`;
  }
  convertDateFormat1(dateStr: string): string {
    const [year, month, day] = dateStr.split('-');
    return `${year}/${month}/${day}`;
  }
  UniquePratiList: any
  getDataAllDistributer() {
    const request = {
      "issue_date": this.issuedate,
      "distributionMode": this.dis_mode,
      "subDistributionMode": this.subDistributionMode,
    }
    this.service.getAllDistributerCopiesForHandDelevery(request).subscribe((data: any) => {
      this.FilteredData = data.data;
      this.totalgatthe = 0;
      const pratiMap: { [key: string]: any } = {};
      this.FilteredData.forEach(item => {
        const pratiValue = item.prati;
        if (pratiMap[pratiValue]) {
          pratiMap[pratiValue].gatthe++;
          // Update ank using the updated gatthe
          pratiMap[pratiValue].ank = pratiMap[pratiValue].prati * pratiMap[pratiValue].gatthe;
          pratiMap[pratiValue].vajan = this.vajan;
          pratiMap[pratiValue].gatthchevajan = 0;
          pratiMap[pratiValue].tapalrate = this.tapalrate;
          pratiMap[pratiValue].aakar = pratiMap[pratiValue].ank * pratiMap[pratiValue].tapalrate;
          // this.totalgatthe = this.totalgatthe + pratiMap[pratiValue].gatthe;
          //  this.totalank = Number(this.totalank + pratiMap[pratiValue].ank);
           this.totalvajan=0
            this.totalaakar=this.totalaakar + pratiMap[pratiValue].aakar;
            console.log()
        } else {
          pratiMap[pratiValue] = { ...item, gatthe: 1 };
          pratiMap[pratiValue].ank = pratiMap[pratiValue].prati * pratiMap[pratiValue].gatthe;
          pratiMap[pratiValue].vajan = this.vajan;
          pratiMap[pratiValue].gatthchevajan = 0;
          pratiMap[pratiValue].tapalrate = this.tapalrate;
          pratiMap[pratiValue].aakar = pratiMap[pratiValue].ank * pratiMap[pratiValue].tapalrate;
          // this.totalgatthe = this.totalgatthe + pratiMap[pratiValue].gatthe;
          //  this.totalank = this.totalank + pratiMap[pratiValue].ank;
           this.totalvajan=0;
           this.totalaakar=this.totalaakar + pratiMap[pratiValue].aakar;
        }
      });
      this.UniquePratiList = Object.values(pratiMap);
      this.FilteredData = this.UniquePratiList;
      // this.totaltapalank=this.UniquePratiList[0].allAdditionGatthe
      this.totaltapalank=Number(this.UniquePratiList[0].allAdditionTotal)
      // this.totaltapalank=this.UniquePratiList[0].allAdditionTotal
      console.log(this.UniquePratiList);
      this.totalgatthe = this.UniquePratiList.reduce((sum, item) => {
        return sum + (parseFloat(item.gatthe) || 0);
      }, 0);
      this.totalank = this.UniquePratiList.reduce((sum, item) => {
      return sum + (parseFloat(item.ank) || 0);
      }, 0);
    });
  }
}
